import React from 'react';
import Login from '../components/Auth/Login';

const LoginPage = ({ onLogin }) => {
  return (
    <div className="bg-gray-900 min-h-screen text-gray-100">
      <Login onLogin={onLogin} />
    </div>
  );
};

export default LoginPage;
